import React, { useEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import DualListbox from "../../Components/DualListbox";

const ResponsabileModal = (props) => {
  const [leftItems, setLeftItems] = useState(props.listaScuole);

  return (
    <>
      {" "}
      <div className="col-6 offset-3">
        <Input
          id="ResponsabileCf"
          label="Responsabile CF"
          className="flex-grow-1"
          type="text"
          value={props.responsabileCf}
          onChange={(e) => props.setResponsabileCf(e.target.value)}
        />
      </div>
      <DualListbox
        id="Servizi"
        leftItems={leftItems}
        setLeftItems={setLeftItems}
        rightItems={props.responsabileListaScuole}
        setRightItems={props.setResponsabileListaScuole}
      ></DualListbox>
    </>
  );
};

export default ResponsabileModal;
